import { InfoCard } from "@sixty-six-north/ui-system"
import React from "react"
import { useTranslation } from "react-i18next"
import { DiscountCodeInfo, LineItem } from "@commercetools/platform-sdk"
import { Box } from "theme-ui"
import { useCartState } from "../../cart/CartServiceHook"
import { useOrderState } from "../../cart/OrderService"
import { getInvalidDiscountCodesForItems } from "../../utils/DiscountUtils"
import { usePreferredLanguage } from "../../i18n/StoreHooks"

interface PromoCodeItemsAlertProps {
  theme?: "light" | "dark"
}

export const PromoCodeItemsAlert: React.FC<PromoCodeItemsAlertProps> = ({
  theme = "dark"
}) => {
  const { t } = useTranslation("checkout")
  const cart = useCartState()
  const order = useOrderState()
  const cartOrOrder = cart || order
  const cartDiscountCodes: Array<DiscountCodeInfo> =
    cartOrOrder?.discountCodes || []
  const language = usePreferredLanguage()
  const lineItems: Array<LineItem> = cartOrOrder?.lineItems || []
  const { invalidDiscountCodes, invalidDiscountItems } =
    getInvalidDiscountCodesForItems({
      cartDiscountCodes,
      lineItems,
      language
    })

  if (!invalidDiscountCodes.length) return null

  return (
    <Box data-testid="promo-code-alert" sx={{ mb: 19, whiteSpace: "pre-line" }}>
      <InfoCard
        title={t("promotionalCodeEligibility")}
        message={t(
          invalidDiscountItems.length > 1
            ? "promotionalCodeEligibilityMessageMultipleItems"
            : "promotionalCodeEligibilityMessageSingleItem",
          {
            invalidDiscountCodes,
            invalidDiscountItems: invalidDiscountItems.join("\n")
          }
        )}
        showIcon={false}
        theme={theme}
      />
    </Box>
  )
}
